<template>
  <div class="yh-page">
    <!-- 操作锁定遮罩 -->
    <div v-if="isProcessing" class="processing-mask">
      <div class="processing-content">
        <el-spinner type="ring" size="48"></el-spinner>
        <p class="processing-text">正在运行中，请勿关闭窗口...</p>
      </div>
    </div>
    <el-card v-loading="loading" :element-loading-text="loadingText">
      <el-row :gutter="10">
        <el-col :span="12">
          <el-select class="w-100" placeholder="请选择保险公司" @change="handleInqueryChange"
                     v-model="inquery_id">
            <el-option v-for="item in inquery_list" :key="item.id"
                       :value="item.id"
                       :label="'[' + item.id + '] ' + item.insurance_name + ' - ' + item.company_name"></el-option>
          </el-select>
        </el-col>
        <el-col :span="12">
          <el-select class="w-100" placeholder="请选择险种方案" v-model="scheme_id" @change="handleSchemeChange">
            <el-option v-for="item in inquery.scheme_list" :key="item.id" :value="item.id"
                       :label="item.name"></el-option>
          </el-select>
        </el-col>
      </el-row>
      <el-row v-if="inquery.status === '7'" :gutter="10" type="flex" class="mt-2">
        <el-col :span="28">
          调整内容：<el-input type="textarea" :autosize="{ minRows: 6, maxRows: 12 }" v-model="inquery.adjust.content"/>
        </el-col>
      </el-row>
      <el-row :gutter="10" type="flex" align="stretch" class="mt-2">
        <el-col :span="12">
          <el-input ref="reply" v-if="inquery && inquery.email" type="textarea"
                    class="w-100" :rows="28"
                    v-model="inquery.email.reply_content"></el-input>
        </el-col>
        <!-- 20240417 报价保存功能框隐藏 -->
        <el-col :span="8" v-if="false">
          <el-tabs type="border-card" class="h-100" v-model="tab_name">
            <el-tab-pane name="1">
              <div slot="label">报价保存</div>
              <el-tree ref="quote" :data="scheme.quoted_content" node-key="id" :highlight-current="true"
                       :key="0" show-checkbox :default-expand-all="true" :default-checked-keys="scheme.quotedCheckedKeys"
                       :expand-on-click-node="false" :render-content="renderContent" @check-change="handleCheckChange"
                       :props="defaultProps" style="height: 480px">
              </el-tree>
              <div class="border-top mt-2 pt-2">
                <el-button type="primary" size="small" @click="handleQuotedSave(scheme)">
                  保存报价
                  <span v-if="scheme.quoted_save" class="el-icon-success ml-2"></span>
                </el-button>
                <!-- <el-tooltip class="item" effect="light" content="同步报价到报价调整" placement="top-start">
                  <el-button type="primary" size="small" @click="handleQuotedSync">同步报价</el-button>
                </el-tooltip> -->
              </div>
            </el-tab-pane>
          </el-tabs>
        </el-col>
        <el-col :span="12">
          <el-tabs type="border-card" class="h-100" v-model="tab_name_2">
            <el-tab-pane name="2">
              <div slot="label">报价调整</div>
              <el-tree ref="quote" :data="scheme.adjusted_content" node-key="id" :highlight-current="true"
                       :key="0" show-checkbox :default-expand-all="true" :default-checked-keys="scheme.adjustedCheckedKeys"
                       :expand-on-click-node="false" :render-content="renderContent" @check-change="handleCheckChange"
                       :props="defaultProps" style="height: 480px">
              </el-tree>
              <div class="border-top mt-2 pt-2">
                <el-button type="primary" size="small" @click="handleAdjustedSave(scheme)">
                  保存调整
                  <span v-if="scheme.adjusted_save" class="el-icon-success ml-2"></span>
                </el-button>
                <!-- 20240417 同步报价功能键隐藏 -->
                <!-- <el-tooltip class="item" effect="light" content="同步报价到报价调整" placement="top-start">
                  <el-button type="primary" size="small" @click="handleQuotedSync">同步报价</el-button>
                </el-tooltip> -->
              </div>
            </el-tab-pane>
          </el-tabs>
        </el-col>
        <!-- 20240417 费率调整功能隐藏 -->
        <el-col :span="6" v-if="false">
          <el-tabs type="border-card" class="h-100" v-model="tab_name">
            <el-tab-pane name="1">
              <div slot="label">费率调整</div>
              
              <div class="sub-title">默认费率：</div>
              <el-input type="number" v-model="scheme.default_rate" placeholder="默认费率" style="width: 260px" class="input" :disabled="true"></el-input>
              
              <div class="sub-title">调整后费率：（默认费率 + 调整费率）</div>
              <el-input type="number" v-model="scheme.rate" placeholder="调整后费率" style="width: 260px" class="input" :disabled="true"></el-input>
              
              <div class="sub-title">调整费率：</div>
              <el-input type="number" v-model="scheme.adjust_rate" placeholder="调整费率" style="width: 260px" class="input" @change="computeRate"></el-input>
              <div class="border-top mt-2 pt-2">
                <el-button type="primary" size="small" @click="handleRateSave(scheme)">
                  保存费率
                </el-button>
              </div>
            </el-tab-pane>
          </el-tabs>
        </el-col>
      </el-row>
      <el-row :gutter="10" class="border-top mt-3 pt-3">
        <!-- 20240417 回复邮件功能隐藏 -->
        <!-- <el-col :span="12">
          <span class="pl-3">
            <el-button :disabled="inquery.getting_status !== '2'" type="primary" size="small" @click="handleReply">
              回复邮件
            </el-button>
          </span>
        </el-col> -->
        <el-col :span="24">
          <span class="pl-3" style="float: right;">
            <!-- 20240417 拒绝调整、完成询价核查功能键隐藏 -->
            <!-- <el-button v-if="inquery.status === '7'" type="primary" size="small" @click="handleChecked('refuse')">
              拒绝调整
              <span v-if="inquery.status === '6'" class="el-icon-success ml-2"></span>
            </el-button>
            <el-button type="primary" size="small" @click="handleChecked('agree')">
              完成询价核查
              <span v-if="inquery.status === '6'" class="el-icon-success ml-2"></span>
            </el-button> -->
            <el-button :disabled="['3','6'].indexOf(inquery.status) === -1" type="primary" size="small" @click="handleCheckEmail">
              发送邮件
              <span v-if="inquery.status === '6'" class="el-icon-success ml-2"></span>
            </el-button>
            <el-button size="small" @click="handleClose">关闭</el-button>
          </span>
        </el-col>
      </el-row>
    </el-card>
    <inquery-check-email-dlg ref="email" @inqueryCheckEmail="getEmailStatus"></inquery-check-email-dlg>
  </div>
</template>

<script>
  import {fetchCheck} from '@/api/inquery'
  import {quotedSave, adjustedSave, inqueryCheck, rateSave} from "@/api/inquery"
  import TypeClause from '@/components/SchemeTree/type-clause'
  import { filterCheckedKeys, filterCheckedNode, gen_content } from '@/utils/insurance_type'
  import { digitUppercase3 } from '@/utils/misc'
  import loading from '@/mixins/loading'
  import InqueryCheckEmailDlg from './inquery-check-email-dlg'


  export default {
    name: "check",
    mixins: [loading],
    components: {
      InqueryCheckEmailDlg
    },
    data() {
      return {
        insurance_id: 0,
        inquery_id: 0,
        scheme_id: 0,
        inquery: {},
        scheme: {},
        inquery_list: [],
        tab_name: '1',
        tab_name_2: '2',
        isProcessing: false,
        // quotedCheckedKeys: [],
        // adjustedCheckedKeys: [],
        defaultProps: {
          label: function (data) {
            return (data.content ? data.content : '[' + data.code + ']')
          },
          children: 'children'
        }
      }
    },
    methods: {
      computeRate(){
        this.scheme.rate = parseFloat(this.scheme.default_rate) + parseFloat(this.scheme.adjust_rate)
        this.scheme.rate = this.scheme.rate.toFixed(2)
      },
      handleInqueryChange(inquery_id) {
        this.inquery = this.inquery_list.find(inquery => {
          return (inquery.id === inquery_id)
        })

        if (this.inquery && this.inquery.scheme_list) {
          this.scheme = this.inquery.scheme_list[0]
          this.scheme_id = this.scheme.id
          this.handleSchemeChange(this.scheme_id)
        }
      },
      handleSchemeChange(scheme_id) {
        this.scheme = this.inquery.scheme_list.find(item => {
          return (item.id === scheme_id)
        })
      },
      handleCheckChange(data, checked, indeterminate) {
        this.$set(data, 'checked', checked)
        this.$set(data, 'indeterminate', indeterminate)
      },
      handleQuotedSave(scheme) {
        quotedSave(scheme.inquery, scheme)
          .then(res => {
            this.$message.success(res.message)
            this.$set(scheme, 'quoted_save', true)
            if (!scheme.adjusted_save) {
              this.$set(scheme, 'adjusted_content', JSON.parse(JSON.stringify(scheme.quoted_content)))
            }
          })
      },
      handleRateSave(scheme){
        rateSave(scheme.inquery, scheme)
          .then(res => {
            this.$message.success(res.message)
          })
      },
      handleAdjustedSave(scheme) {
        adjustedSave(scheme.inquery, scheme)
          .then(res => {
            this.$message.success(res.message)
            this.$set(scheme, 'adjusted_save', true)
          })
      },
      handleQuotedSync() {
        this.$set(this.scheme, 'adjusted_content', JSON.parse(JSON.stringify(this.scheme.quoted_content)))
        this.$set(this.scheme, 'adjustedCheckedKeys', filterCheckedKeys(this.scheme.adjusted_content))
        this.$message.success("已同步报价到[报价保存]’")
      },
      handleCheck() {
        this.loading = true
        fetchCheck(this.insurance_id)
          .then(res => {
            this.inquery_list = res;
            this.inquery_list.forEach(inquery => {
              inquery.scheme_list.forEach(scheme => {
                if (scheme) {
                  if (scheme.quoted_content === null || JSON.stringify(scheme.quoted_content) === '{}') {
                    if (scheme.children) {
                      this.$set(scheme, 'quoted_content', scheme.children)
                    } else {
                      this.$set(scheme, 'quoted_content', scheme.origin_children)
                    }
                  } else {
                    this.$set(scheme, 'quoted_save', true)
                  }

                  if (scheme.adjusted_content === null || JSON.stringify(scheme.adjusted_content) === '{}') {
                    if (scheme.children) {
                      this.$set(scheme, 'adjusted_content', JSON.parse(JSON.stringify(scheme.children)))
                    } else {
                      this.$set(scheme, 'adjusted_content', JSON.parse(JSON.stringify(scheme.origin_children)))
                    }
                  } else {
                    this.$set(scheme, 'adjusted_save', true)
                  }

                  this.$set(scheme, 'quotedCheckedKeys', filterCheckedKeys(scheme.quoted_content))
                  this.$set(scheme, 'adjustedCheckedKeys', filterCheckedKeys(scheme.adjusted_content))
                }
              })
            })
            this.inquery_id = this.inquery_id ? parseInt(this.inquery_id) : this.inquery_list[0].id
            this.handleInqueryChange(this.inquery_id)
            this.loading = false
          })
          .catch(error => {
            this.loading = false
            this.$error_message(error)
          })
      },
      // 自动保存未保存的方案
      async autoSaveSchemes() {
        let not_saved_list = this.inquery.scheme_list.filter(scheme => {
          return(!scheme.quoted_save || !scheme.adjusted_save)
        })
        
        if (not_saved_list.length === 0) return
        
        this.loadingText = "正在自动保存未保存的方案，请稍等..."
        
        for (let scheme of not_saved_list) {
          if (!scheme.quoted_save) {
            await quotedSave(scheme.inquery, scheme)
            this.$set(scheme, 'quoted_save', true)
            // this.$message.success("询价方案[" + scheme.name + "]已自动保存")
          }
          await adjustedSave(scheme.inquery, scheme)
          this.$set(scheme, 'adjusted_save', true)
          // this.$message.success("询价方案[" + scheme.name + "]已自动保存")
        }
      },
      
      // 执行询价核查
      async doInqueryCheck(type) {
        this.loadingText = "正在完成询价核查，请稍等..."
        this.inquery.action = type
        
        try {
          let res = await inqueryCheck(this.inquery.id, this.inquery)
          this.$message.success(res.message)
          this.handleCheck()
        } catch (error) {
          this.$error_message(error)
          this.loading = false
        } finally {
          this.isProcessing = false
        }
      },
      
      handleChecked(type) {
        this.loading = true
        
        // 自动保存未保存的方案，然后执行询价核查
        this.autoSaveSchemes()
          .then(() => this.doInqueryCheck(type))
          .catch(error => {
            this.$error_message(error)
            this.loading = false
            this.isProcessing = false
          })
      },
      handleCheckEmail() {       
        let email_content = '', format_content = '', data = {}

        this.inquery.scheme_list.forEach((scheme, index) => {
          if(scheme.adjusted_content && scheme.adjusted_content.length > 0) {
            let temp_scheme = JSON.parse(JSON.stringify(scheme))
            temp_scheme.children = temp_scheme.adjusted_content.filter(section => {
              return filterCheckedNode(section)
            })

            format_content = gen_content(temp_scheme)
            email_content = email_content.concat(digitUppercase3(index + 1) + '、' + scheme.name + '\n\n' + format_content + '\n')
          }
        })

        data.insurance_name = this.inquery.insurance_name
        data.company_name = this.inquery.company_name
        data.email_content = email_content

        this.$refs.email.handleOpen(this.inquery_id, data)
      },
      getEmailStatus(s) {
        // 锁定页面，防止用户关闭
        this.isProcessing = true

        if (s === true) {
          this.handleChecked('agree')
        } else {
          // 邮件发送失败或取消，解锁页面
          this.isProcessing = false
        }
      },
      handleReply() {
        this.$router.push({name: 'inquerySend', query: {insurance_id: this.insurance_id, inquery_id: this.inquery_id, email_type: 'inquery_reply'}})
      },
      handleClose() {
        // window.opener = null
        // window.close()
        this.$goBack(this.$router)
      },
      renderContent(h, {node, data}) {
        // let that = this
        if (data.children === undefined) {		// clause
          let elem = [], label_list = node.label.split(/{([\w|_][\w|_|\d]+)}/g)
          if (label_list.length === 1) {
            return h('span', node.label)
          } else {
            label_list.forEach(label => {
              let have_var = data.variables.find(v => {
                return (v.code === label)
              })

              if (have_var) {
                let el = h(TypeClause,
                  {
                    key: have_var.code + have_var.value,
                    props: {variable: have_var},
                    on: {
                      update: function (value) {
                        have_var = value
                      }
                    }
                  })
                elem.push(el)
              } else {
                elem.push(label)
              }
            })
            return h('span', elem)
          }
        } else {	// section
          return h('span', node.label)
        }
      }
    },
    created() {
      this.insurance_id = this.$route.query.insurance_id
      this.inquery_id = this.$route.query.inquery_id
      if (this.insurance_id !== undefined) {
        this.insurance_id = parseInt(this.insurance_id)
        if (this.$route.name === 'inqueryCheck' && this.$perm(['inquery.inquery_check'])) {
          this.handleCheck()
        } else {
          this.$router.push('/401')
        }
      } else {
        this.$router.push('/404')
      }
    }
  }
</script>

<style scoped>
.processing-mask {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.6);
  z-index: 9999;
  display: flex;
  align-items: center;
  justify-content: center;
}

.processing-content {
  display: flex;
  flex-direction: column;
  align-items: center;
  background-color: #fff;
  padding: 40px 60px;
  border-radius: 8px;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.15);
}

.processing-text {
  margin-top: 20px;
  font-size: 16px;
  color: #333;
}
</style>
